function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { Toggle, Layout } from "../../../native";
import { useFormContext } from "../FormContext";

const RadioWidget = ({
  options,
  value,
  disabled,
  readonly,
  onChange,
  formContext
}) => {
  const {
    enumOptions,
    enumDisabled
  } = options;

  const _onChange = newValue => onChange(newValue);

  const {
    mapping,
    radioLabelMapping
  } = useFormContext(formContext);
  return /*#__PURE__*/React.createElement(Layout, null, enumOptions.map((option, i) => {
    const itemDisabled = enumDisabled && enumDisabled.indexOf(option.value) !== -1;
    return /*#__PURE__*/React.createElement(Toggle, _extends({}, mapping.toggle, {
      style: [mapping.toggle.style],
      key: i,
      onChange: () => _onChange(option.value),
      checked: option.value === value,
      disabled: disabled || itemDisabled || readonly
    }), radioLabelMapping ? radioLabelMapping(option.label) : option.label);
  }));
};

export default RadioWidget;